import React from "react";
import Header from "./Header";

const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-black text-white">
    <Header />
    <main className="flex-1 flex flex-col items-center bg-valia-background-primary">
      <div className="w-full max-w-7xl px-4 sm:px-6 lg:px-8 flex-1 py-8">
        {children}
      </div>
    </main>
  </div>
);

export default PublicLayout;
